// extracted by mini-css-extract-plugin
module.exports = {"bq_card_slip":"CardFilp_bq_card_slip__1Zw-L"};